import WorldCupCard1 from "../assets/img/fifa/world-cup-1.png";
import WorldCupCard2 from "../assets/img/fifa/world-cup-2.png";
import Fifa2k26Card1 from "../assets/img/fifa/fifa-cup-1.png";
import Fifa2k26Card2 from "../assets/img/fifa/fifa-cup-2.png";
import MosidaCard from "../assets/img/fifa/mosida-card.png";
import type { FifaCardDesignId } from "./stationFlowStorage";

export function resolveFifaGeneratedCardPreview(
  designId: FifaCardDesignId | null,
  attempt = 0
): string {
  const variant = attempt % 2;

  switch (designId) {
    case "fifa-2k26":
      return variant === 0 ? Fifa2k26Card1 : Fifa2k26Card2;
    case "mosida":
      return MosidaCard;
    case "world-cup-2026":
    default:
      return variant === 0 ? WorldCupCard1 : WorldCupCard2;
  }
}
